import * as React from "react";
import {Alert} from "react-bootstrap"
import {connect} from "react-redux";
import withRequestState from "../../components/WithRequestState";
import { RequestStateProps } from "../../interfaces/RequestState";
import { withRouter, RouteComponentProps } from "react-router-dom";


interface IProps {
}

class Reports extends React.Component<IProps & RequestStateProps & RouteComponentProps> {

    render(){
        return (
            <div className="p-4">
                
                <Alert variant="primary" className="mt-4">
                    Reports
                </Alert>
               


            </div>
        )
    }

}


export default withRouter(connect(
    null, null
)(withRequestState(Reports, [])));